import { useState } from "react";
import { Outlet } from "react-router-dom";

import { MobileNavbar } from "./mobile-navbar";
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";

/**
 * AppShell — layout principal con sidebar + topbar/mobilenavbar + content.
 *
 * Comportamiento responsive:
 *   - lg+ (desktop): Sidebar fijo + Topbar arriba (como antes)
 *   - <lg (mobile/tablet): Sidebar oculto, MobileNavbar visible con botón hamburguesa
 *
 * Estado:
 *   - mobileSidebarOpen: controla el drawer del sidebar en mobile
 *
 * Las páginas hijas (Outlet) pueden detectar mobile por su cuenta usando
 * useIsMobile() y adaptarse según viewport.
 */
export function AppShell() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-background">
      <Sidebar
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />

      <div className="flex min-w-0 flex-1 flex-col">
        {/* Mobile navbar - solo visible <lg */}
        <MobileNavbar
          onMenuClick={() => setMobileSidebarOpen(true)}
        />

        {/* Desktop topbar - oculto en mobile */}
        <div className="hidden lg:block">
          <Topbar />
        </div>

        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
